import React from 'react';
import { Link } from 'react-router-dom';
import SectionTitle from '../../components/SectionTitle';
import Button from '../../components/Button';
import SingleServiceFour from '../../components/Service/SingleServiceFour';

import serviceBG from '../../assets/img/service/bg-4.png';
import serviceImg1 from '../../assets/img/service/service-2-1.jpg';
import serviceImg2 from '../../assets/img/service/service-2-2.jpg';
import serviceImg3 from '../../assets/img/service/service-2-3.jpg';

const Service = () => {
  return (
    <div
      className="it-service-2-area it-service-2-bg grey-bg-4 pt-120 pb-90"
      style={{ backgroundImage: `url(${serviceBG})` }}
    >
      <div id="it-service" className="container">
        <div className="it-service-2-title-wrapper mb-65">
          <div className="row align-items-end">
            <div className="col-xl-6 col-lg-6 col-md-8">
              <SectionTitle
                itemClass="it-service-2-title-box"
                subTitleClass="it-section-subtitle green"
                subTitle="OUR SERVICES"
                titleClass="it-section-title"
                title="Services We Provide."
              />
            </div>
            <div className="col-xl-6 col-lg-6 col-md-4">
              <div className="it-service-2-button text-md-end">
                <Link className="it-btn-theme grey-bg" to="/service">
                  <Button btnText="View All Services" />
                </Link>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div
            className="col-xl-4 col-lg-4 col-md-6 mb-30 wow animate__fadeInUp"
            data-wow-duration=".9s"
            data-wow-delay=".3s"
          >
            <SingleServiceFour
              serviceImage={serviceImg1}
              icon="flaticon-kiss"
              title="Dating & Relation"
              description=" Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                  do eiusmod tempor incididunt"
            />
          </div>
          <div
            className="col-xl-4 col-lg-4 col-md-6 mb-30 wow animate__fadeInUp"
            data-wow-duration=".9s"
            data-wow-delay=".5s"
          >
            <SingleServiceFour
              serviceImage={serviceImg2}
              icon="flaticon-kiss"
              title="Anxiety Disorder"
              description=" Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                  do eiusmod tempor incididunt"
            />
          </div>
          <div
            className="col-xl-4 col-lg-4 col-md-6 mb-30 wow animate__fadeInUp"
            data-wow-duration=".9s"
            data-wow-delay=".7s"
          >
            <SingleServiceFour
              serviceImage={serviceImg3}
              icon="flaticon-kiss"
              title="Family Counseling"
              description=" Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                  do eiusmod tempor incididunt"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Service;
